"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const utils_1 = require("../../molecules/utils");
const typography_1 = require("../../shared/typography");
exports.default = ({ rating, sumOfRatings, translations }) => {
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(utils_1.RatingStars, { rate: parseInt(rating) }, void 0), (0, jsx_runtime_1.jsx)(RatingsWrapper, { children: (0, jsx_runtime_1.jsx)(typography_1.P, { children: `${rating} / 5` }, void 0) }, void 0)] }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: `${sumOfRatings} ${translations.reviews}` }, void 0)] }, void 0));
};
const Wrapper = styled_components_1.default.div `
  margin-top: ${({ theme }) => theme.spacings.xl};

  & > div {
    align-items: center;
    display: flex;
    margin: ${({ theme }) => `${theme.spacings.xs} 0`};
    width: 100%;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    margin-top: 0;
    padding: ${({ theme }) => `0 ${theme.spacings.m}`};
  }
`;
const RatingsWrapper = styled_components_1.default.div `
  margin-left: ${({ theme }) => theme.spacings.s};

  p {
    color: ${({ theme }) => theme.colors.greyBase};
    line-height: 1.5rem;
    margin-bottom: 0;
  }

  & span {
    color: ${({ theme }) => theme.colors.greyLighten40};
  }
`;
//# sourceMappingURL=TopBar.js.map